[
  {
    "id": 0,
    "value": "Global"
  },
  {
    "id": 1,
    "value": "Account"
  },
  {
    "id": 2,
    "value": "AccountPeriod"
  },
  {
    "id": 3,
    "value": "Channel"
  },
  {
    "id": 4,
    "value": "ChannelPeriod"
  }
]